import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { VendorService } from '../../../services/vendor.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';

@Component({
	selector: 'app-all-vendors',
	templateUrl: './all-vendors.component.html',
	styleUrls: ['./all-vendors.component.scss'],
	animations: [
		trigger('flipState', [
			state('active', style({
				transform: 'rotate3d(0, 1, 0, 179deg)',
			})),
			state('inactive', style({
				transform: 'rotateY(0)'
			})),
			transition('active => inactive', animate('500ms ease-out')),
			transition('inactive => active', animate('500ms ease-in')),
		]),
	]
})
export class AllVendorsComponent implements OnInit {

	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();
	viewing: any = false;

	data: any = false;
	title = 'All Vendors';
	total: any = 0;
	config: any = [];
	user: any = false;
	
	constructor(private globalSearchService: GlobalSearchService, private vendorService: VendorService) {
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.globalSearchService.user.subscribe(u => {
				this.user = u;
			});
		});
	}

	ngOnInit(): void {
		this.vendorService.getVendorsPost({ inc_disabled: false }).subscribe(async (results: any) => {
			this.data = results;
			this.total = results.length;
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: this.title };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewData.emit(false);
		}
	}
}









